import { FC, ReactNode, useEffect, useState } from 'react';

import { Loader } from '@pp/core/src/components/loader/index';
import { useModifiers } from '@pp/core/src/styles/hooks/useModifiers';

import { useLastGameDataFetcher } from '../../../store/apiHooks/useLastGameDataFetcher';
import { useGameDispatch } from '../../../store/GameStore';
import { useHighflyerGameStateSlice } from '../../../store/slices/highflyerGame/selectors';
import { highflyerGameStateActions } from '../../../store/slices/highflyerGame/slice';
import { ErrorMessage } from '../errorMessage/ErrorMessage';
import { ScrollableWrapper } from '../scrollableWrapper/ScrollableWrapper';

import { BetHistoryTable } from './betsHistory/BetsHistoryTable';
import { CashedAndTotalBets } from './cashedAndTotalBets/CashedAndTotalBets';
import { PreviousRound } from './previousRound/PreviousRound';

import styles from './TableBetsConnected.module.css';

export const TableBetsConnected: FC = () => {
  const dispatch = useGameDispatch();
  const [show, setShow] = useState(true);
  const lastGameDataFetcher = useLastGameDataFetcher();
  const lastGameData = useHighflyerGameStateSlice.lastGameData()?.players;
  const isLoading = useHighflyerGameStateSlice.getIsLoadingPreviousGameData();
  const isLoadMore = useHighflyerGameStateSlice.getIsLoadMorePreviousGameData();
  const isApiRejected = useHighflyerGameStateSlice.getIsApiRejected();

  const mods = useModifiers(styles, 'tableBets_previous', {
    content: !show,
  });
  const containerMods = useModifiers(
    styles,
    'tableBets_container',
    {
      previous: !show,
      loader: !lastGameData && !show,
    },
    { withBaseClass: true }
  );

  useEffect(() => {
    if (!show) {
      lastGameDataFetcher(true);
    } else {
      dispatch(highflyerGameStateActions.setErrorOccured());
    }
  }, [show]);

  return (
    <div className={containerMods}>
      <PreviousRound show={show} setShow={setShow} />
      {((): ReactNode => {
        if (!lastGameData && !show && !isApiRejected) {
          return <Loader />;
        } else if (!lastGameData && !show && isApiRejected) {
          return (
            <ErrorMessage
              title="HIGHFLYER_FAILED_TO_LOAD"
              message="HIGHFLYER_INTERNAL_ERROR"
              disabled={!isLoadMore}
              loading={isLoading}
              onClick={(): void => lastGameDataFetcher(true)}
            />
          );
        } else {
          return (
            <>
              <CashedAndTotalBets show={show} />
              <ScrollableWrapper>
                <div className={`${styles.tableBets_content} ${mods}`}>
                  <BetHistoryTable show={show} />
                </div>
              </ScrollableWrapper>
            </>
          );
        }
      })()}
    </div>
  );
};
